import { SearchOutlined } from "@ant-design/icons";
import { DatePicker, Modal } from "antd";
import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import dayjs from "dayjs";
import { DateFormat } from "../../../../utils/contact";
import "./Modal.scss";

const ModalSearch = ({ openModal, setOpenModal, onChangeSearch }) => {
  const { t } = useTranslation();

  const SearchField = {
    reportName: "",
    startDate: "",
    dueDate: "",
    hostName: "",
    cpu: "",
    memory: "",
    diskInfo: "",
    os: "",
    packageList: "",
    kernel: "",
  };
  const { RangePicker } = DatePicker;
  const [searchData, setSearchData] = useState(SearchField);
  const handleChangeValue = (name, value) => {
    setSearchData({ ...searchData, [name]: value });
  };

  const handleDatePicker = (value) => {
    setSearchData({
      ...searchData,
      startDate: value === null ? "" : dayjs(value[0]).format(DateFormat),
      dueDate: value === null ? "" : dayjs(value[1]).format(DateFormat),
    });
  };

  const handleSearch = () => {
    onChangeSearch(searchData);
    setOpenModal(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const resetData = () => { // eslint-disable-line no-unused-vars
    setSearchData(SearchField);
  };
  return (
    <Modal
      open={openModal}
      footer={null}
      onCancel={() => setOpenModal(false)}
      width={800}
      className="search-modal"
    >
      <div className="search-container">
        <div className="search-row">
          <div className="search-field">
            <label>{t('history.search.reportName')}</label>
            <input
              type="text"
              value={searchData.reportName}
              onChange={(e) => handleChangeValue("reportName", e?.target?.value)}
              placeholder="Enter report name"
              onKeyDown={handleKeyDown}
            />
          </div>
          <div className="search-field">
            <label>{t('history.search.registeredDate')}</label>
            <RangePicker
              onChange={handleDatePicker}
              value={
                searchData.startDate && searchData.dueDate
                  ? [
                      dayjs(searchData.startDate, DateFormat),
                      dayjs(searchData.dueDate, DateFormat),
                    ]
                  : null
              }
              format={DateFormat}
              allowClear={true}
            />
          </div>
        </div>

        <div className="search-row">
          <div className="search-field">
            <label>{t('history.search.host')}</label>
            <input
              type="text"
              value={searchData.hostName}
              onChange={(e) => handleChangeValue("hostName", e?.target?.value)}
              placeholder="Enter hostname"
              onKeyDown={handleKeyDown}
            />
          </div>
          <div className="search-field">
            <label>CPU</label>
            <input
              type="text"
              value={searchData.cpu}
              onChange={(e) => handleChangeValue("cpu", e?.target?.value)}
              placeholder="Enter CPU info"
              onKeyDown={handleKeyDown}
            />
          </div>
        </div>

        <div className="search-row">
          <div className="search-field">
            <label>{t('history.search.memory')}</label>
            <input
              type="text"
              value={searchData.memory}
              onChange={(e) => handleChangeValue("memory", e?.target?.value)}
              placeholder="Enter memory info"
              onKeyDown={handleKeyDown}
            />
          </div>
          <div className="search-field">
            <label>{t('history.search.disk')}</label>
            <input
              type="text"
              value={searchData.diskInfo}
              onChange={(e) => handleChangeValue("diskInfo", e?.target?.value)}
              placeholder="Enter disk info"
              onKeyDown={handleKeyDown}
            />
          </div>
        </div>

        <div className="search-row">
          <div className="search-field">
            <label>OS</label>
            <input
              type="text"
              value={searchData.os}
              onChange={(e) => handleChangeValue("os", e?.target?.value)}
              placeholder="Enter OS info"
              onKeyDown={handleKeyDown}
            />
          </div>
          <div className="search-field">
            <label>{t('history.search.kernel')}</label>
            <input
              type="text"
              value={searchData.kernel}
              onChange={(e) => handleChangeValue("kernel", e?.target?.value)}
              placeholder="Enter kernel info"
              onKeyDown={handleKeyDown}
            />
          </div>
        </div>

        <div className="search-row">
          <div className="search-field">
            <label>{t('history.search.packageName')}</label>
            <input
              type="text"
              value={searchData.packageList}
              onChange={(e) => handleChangeValue("packageList", e?.target?.value)}
              placeholder="Enter package name"
              onKeyDown={handleKeyDown}
            />
          </div>
          <button className="search-button" onClick={handleSearch}>
            <SearchOutlined /> Search
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalSearch;
